import { useEffectOnce } from 'react-use';
import LogRocket from 'logrocket';

export const useLogRocketInit = () => {
    useEffectOnce(() => {
        try {
            LogRocket.init('tgnae8/codeless');
        } catch (e) {
            console.info('LogRocket initialization failed:', e);
        }
    });
};
